// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608250959/js/" + chunkId + "." + {"44":"587a7604","225":"a57ea88e","481":"e801ecdb","486":"91e0638f","770":"6aca6cf2"}[chunkId] + ".0.5882900406860703.chunk.js";
};